import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _35a0705b = () => interopDefault(import('../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _5251b5f9 = () => interopDefault(import('../pages/advantage/index.vue' /* webpackChunkName: "pages/advantage/index" */))
const _217d2afc = () => interopDefault(import('../pages/apply/index.vue' /* webpackChunkName: "pages/apply/index" */))
const _0ee17b89 = () => interopDefault(import('../pages/cooperation/index.vue' /* webpackChunkName: "pages/cooperation/index" */))
const _8db47ac4 = () => interopDefault(import('../pages/countryIntroduction/index.vue' /* webpackChunkName: "pages/countryIntroduction/index" */))
const _59f0d1db = () => interopDefault(import('../pages/hot/index.vue' /* webpackChunkName: "pages/hot/index" */))
const _018409db = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _9ddcd306 = () => interopDefault(import('../pages/product/index.vue' /* webpackChunkName: "pages/product/index" */))
const _0ca94a0f = () => interopDefault(import('../pages/studyTour/index.vue' /* webpackChunkName: "pages/studyTour/index" */))
const _2da34091 = () => interopDefault(import('../pages/success/index.vue' /* webpackChunkName: "pages/success/index" */))
const _5515f3d4 = () => interopDefault(import('../pages/university/index.vue' /* webpackChunkName: "pages/university/index" */))
const _1a5c94d3 = () => interopDefault(import('../pages/user/index.vue' /* webpackChunkName: "pages/user/index" */))
const _a5a61dd4 = () => interopDefault(import('../pages/user/index/index.vue' /* webpackChunkName: "pages/user/index/index" */))
const _771f5a99 = () => interopDefault(import('../pages/user/index/accommodation/index.vue' /* webpackChunkName: "pages/user/index/accommodation/index" */))
const _acd08098 = () => interopDefault(import('../pages/user/index/account/index.vue' /* webpackChunkName: "pages/user/index/account/index" */))
const _36d6b4a6 = () => interopDefault(import('../pages/user/index/appointment/index.vue' /* webpackChunkName: "pages/user/index/appointment/index" */))
const _70ee081a = () => interopDefault(import('../pages/user/index/commission/index.vue' /* webpackChunkName: "pages/user/index/commission/index" */))
const _ba2ecf12 = () => interopDefault(import('../pages/user/index/download/index.vue' /* webpackChunkName: "pages/user/index/download/index" */))
const _69feb146 = () => interopDefault(import('../pages/user/index/faq/index.vue' /* webpackChunkName: "pages/user/index/faq/index" */))
const _4d6bf23c = () => interopDefault(import('../pages/user/index/service/index.vue' /* webpackChunkName: "pages/user/index/service/index" */))
const _04ee7e42 = () => interopDefault(import('../pages/user/index/student/index.vue' /* webpackChunkName: "pages/user/index/student/index" */))
const _098f1a49 = () => interopDefault(import('../pages/user/index/training/index.vue' /* webpackChunkName: "pages/user/index/training/index" */))
const _09274f47 = () => interopDefault(import('../pages/user/index/application/details.vue' /* webpackChunkName: "pages/user/index/application/details" */))
const _f1851576 = () => interopDefault(import('../pages/user/index/order/details.vue' /* webpackChunkName: "pages/user/index/order/details" */))
const _0dfb0c9c = () => interopDefault(import('../pages/user/index/student/details.vue' /* webpackChunkName: "pages/user/index/student/details" */))
const _33a349c9 = () => interopDefault(import('../pages/visa/index.vue' /* webpackChunkName: "pages/visa/index" */))
const _16be4b0b = () => interopDefault(import('../pages/hot/details.vue' /* webpackChunkName: "pages/hot/details" */))
const _2663830b = () => interopDefault(import('../pages/news/details.vue' /* webpackChunkName: "pages/news/details" */))
const _7bf346f4 = () => interopDefault(import('../pages/university/details.vue' /* webpackChunkName: "pages/university/details" */))
const _fc53f2c6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _35a0705b,
    name: "about"
  }, {
    path: "/advantage",
    component: _5251b5f9,
    name: "advantage"
  }, {
    path: "/apply",
    component: _217d2afc,
    name: "apply"
  }, {
    path: "/cooperation",
    component: _0ee17b89,
    name: "cooperation"
  }, {
    path: "/countryIntroduction",
    component: _8db47ac4,
    name: "countryIntroduction"
  }, {
    path: "/hot",
    component: _59f0d1db,
    name: "hot"
  }, {
    path: "/news",
    component: _018409db,
    name: "news"
  }, {
    path: "/product",
    component: _9ddcd306,
    name: "product"
  }, {
    path: "/studyTour",
    component: _0ca94a0f,
    name: "studyTour"
  }, {
    path: "/success",
    component: _2da34091,
    name: "success"
  }, {
    path: "/university",
    component: _5515f3d4,
    name: "university"
  }, {
    path: "/user",
    component: _1a5c94d3,
    children: [{
      path: "",
      component: _a5a61dd4,
      name: "user-index"
    }, {
      path: "accommodation",
      component: _771f5a99,
      name: "user-index-accommodation"
    }, {
      path: "account",
      component: _acd08098,
      name: "user-index-account"
    }, {
      path: "appointment",
      component: _36d6b4a6,
      name: "user-index-appointment"
    }, {
      path: "commission",
      component: _70ee081a,
      name: "user-index-commission"
    }, {
      path: "download",
      component: _ba2ecf12,
      name: "user-index-download"
    }, {
      path: "faq",
      component: _69feb146,
      name: "user-index-faq"
    }, {
      path: "service",
      component: _4d6bf23c,
      name: "user-index-service"
    }, {
      path: "student",
      component: _04ee7e42,
      name: "user-index-student"
    }, {
      path: "training",
      component: _098f1a49,
      name: "user-index-training"
    }, {
      path: "application/details",
      component: _09274f47,
      name: "user-index-application-details"
    }, {
      path: "order/details",
      component: _f1851576,
      name: "user-index-order-details"
    }, {
      path: "student/details",
      component: _0dfb0c9c,
      name: "user-index-student-details"
    }]
  }, {
    path: "/visa",
    component: _33a349c9,
    name: "visa"
  }, {
    path: "/hot/details",
    component: _16be4b0b,
    name: "hot-details"
  }, {
    path: "/news/details",
    component: _2663830b,
    name: "news-details"
  }, {
    path: "/university/details",
    component: _7bf346f4,
    name: "university-details"
  }, {
    path: "/",
    component: _fc53f2c6,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
